var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrdrrLogoWht(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 131.773,
    height: 51.041,
    viewBox: "0 0 131.773 51.041",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 81.773,
    height: 36.515,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 44.972,
    height: 51.041,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-top",
    transform: "translate(-270 -48.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(320 55.834)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "ordr",
    transform: "translate(0 28.895)",
    fill: "#3e51a1",
    fontSize: 30.785,
    fontFamily: "Comfortaa-Bold, Comfortaa",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ordr")), /*#__PURE__*/React.createElement("text", {
    id: "r",
    transform: "translate(67.358 28.895)",
    fill: "#d51a66",
    fontSize: 30.785,
    fontFamily: "Comfortaa-Bold, Comfortaa",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "r")))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(270 48.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M23.142,2.585,36.764,9.231c1.155.522,1.547,1.775,1.616,3.089V28.066a4.536,4.536,0,0,1-1.917,3.416L22.82,41.98a3.942,3.942,0,0,1-3.839.539L4.07,36.773c-1.365-.48-1.832-1.82-1.914-3.252V16.312a4.63,4.63,0,0,1,2.266-3.633L19.309,2.751a3.841,3.841,0,0,1,3.833-.166",
    fill: "#3e51a1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M23.142,2.585,36.764,9.231c1.155.522,1.547,1.775,1.616,3.089V28.066a4.536,4.536,0,0,1-1.917,3.416L22.82,41.98a3.942,3.942,0,0,1-3.839.539L4.07,36.773c-1.365-.48-1.832-1.82-1.914-3.252V16.312a4.63,4.63,0,0,1,2.266-3.633L19.309,2.751a3.841,3.841,0,0,1,3.833-.166",
    fill: "none",
    stroke: "#3e51a1",
    strokeMiterlimit: 10,
    strokeWidth: 4.309
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M27.93,9.129l13.307,6.353c1.129.5,1.512,1.729,1.579,3.028V34.077a4.579,4.579,0,0,1-1.873,3.406L27.616,48.063a3.834,3.834,0,0,1-3.749.59L9.316,43.2c-1.331-.455-1.786-1.77-1.866-3.183V23.021A4.67,4.67,0,0,1,9.66,19.4L24.187,9.354a3.723,3.723,0,0,1,3.743-.225",
    fill: "#d51a66",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M27.93,9.129l13.307,6.353c1.129.5,1.512,1.729,1.579,3.028V34.077a4.579,4.579,0,0,1-1.873,3.406L27.616,48.063a3.834,3.834,0,0,1-3.749.59L9.316,43.2c-1.331-.455-1.786-1.77-1.866-3.183V23.021A4.67,4.67,0,0,1,9.66,19.4L24.187,9.354a3.723,3.723,0,0,1,3.743-.225",
    fill: "none",
    stroke: "#d51a66",
    strokeMiterlimit: 10,
    strokeWidth: 4.309
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M25.571,5.976,39.032,12.47c1.143.51,1.53,1.752,1.6,3.058V31.183a4.559,4.559,0,0,1-1.9,3.412L25.253,45.138a3.889,3.889,0,0,1-3.793.565L6.732,40.108c-1.348-.467-1.808-1.794-1.89-3.216v-17.1A4.651,4.651,0,0,1,7.08,16.163l14.7-9.99a3.778,3.778,0,0,1,3.787-.2",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M25.571,5.976,39.032,12.47c1.143.51,1.53,1.752,1.6,3.058V31.183a4.559,4.559,0,0,1-1.9,3.412L25.253,45.138a3.889,3.889,0,0,1-3.793.565L6.732,40.108c-1.348-.467-1.808-1.794-1.89-3.216v-17.1A4.651,4.651,0,0,1,7.08,16.163l14.7-9.99a3.778,3.778,0,0,1,3.787-.2",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 4.309
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdrrLogoWht);
export default __webpack_public_path__ + "static/media/ordrr-logo-wht.388a3112fca744aec145fdb44a18cda3.svg";
export { ForwardRef as ReactComponent };